module.exports = __webpack_public_path__ + "static/media/2-6.2a71447a.png";